export default __webpack_public_path__ + "static/media/location.3a425058.svg";